// @router
const newContainer = () => import("@/layouts/Default.vue");
const jobsList = () => import("../views/jobs-list/jobsList.vue");
const detail = () => import("../views/detail.vue");
const jobSelectedIndicatorsListWrapper = () =>
  import("../views/job-indicators-list/jobSelectedIndicatorsListWrapper.vue");
const jobSelectedMyIndicatorsListWrapper = () =>
  import("../views/job-indicators-list/jobSelectedMyIndicatorsListWrapper.vue");
const tasks = () => import("../views/tasks/tasks.vue");
const technologies = () => import("../views/technologies/technologies.vue");
const toolsUsed = () => import("../views/tools-used/toolsUsed.vue");
const workActivities = () =>
  import("../views/work-activities/workActivities.vue");
const detailWorkActivities = () =>
  import("../views/detail-work-activities/detailWorkActivities.vue");
const workContexts = () => import("../views/work-context/workContexts.vue");
const skills = () => import("../views/skills/skills.vue");
const knowledge = () => import("../views/knowledge/knowledge.vue");
const abilities = () => import("../views/abilities/abilities.vue");
const workValues = () => import("../views/work-values/workValues.vue");
const workStyles = () => import("../views/work-styles/workStyles.vue");
const interests = () => import("../views/interests/interests.vue");
const educations = () => import("../views/educations/educations.vue");
const jobMatchingPerson = () =>
  import("../views/job-matching-person/jobMatchingPerson.vue");
const jobpReferencesList = () =>
  import("../views/jobp-references/jobpReferencesList.vue");

const occupationDataParvandehList = () =>
  import(
    "../views/job-matching-person/components/occupationDataParvandehList.vue"
  );

export const jobsProfileRoutes: any[] = [
  {
    path: "/jobs-profile",
    name: "jobs_profile",
    meta: {
      label: "خانه",
      requiresAuth: true,
      redesigned: true,
      moduleName: "jobsProfile",
    },
    component: newContainer,
    redirect: "/jobs-profile/list",
    children: [
      {
        path: "list",
        name: "jobs-profile-list",
        component: jobsList,
        meta: {
          label: "جستجوی شغل",
          requiresAuth: true,
          redesigned: true,
        },
      },
      {
        path: "job/:code",
        name: "jobs-profile-job",
        component: detail,
        meta: {
          label: "شغل",
          requiresAuth: true,
          hasMaxWidth: false,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: ":code/indicators",
        name: "jobs-profile-selected-indicators",
        component: jobSelectedIndicatorsListWrapper,
        meta: {
          label: "شاخص‌های شغل",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: ":code/my-indicators",
        name: "my-jobs-profile-selected-indicators",
        component: jobSelectedMyIndicatorsListWrapper,
        meta: {
          label: "شاخص‌های شغل",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job/:code/tasks",
        name: "jobs-profile-tasks",
        component: tasks,
        meta: {
          label: "وظایف",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job/:code/technologies",
        name: "jobs-profile-technologies",
        component: technologies,
        meta: {
          label: "مهارت‌های فناورانه",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job/:code/tools-used",
        name: "jobs-profile-tools-used",
        component: toolsUsed,
        meta: {
          label: "ابزارهای مورد استفاده",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job/:code/work-activities",
        name: "jobs-profile-work-activities",
        component: workActivities,
        meta: {
          label: "فعالیت‌های کاری",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job/:code/detail-work-activities",
        name: "jobs-profile-detail-work-activities",
        component: detailWorkActivities,
        meta: {
          label: "جزییات فعالیت‌های کاری",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job/:code/work-contexts",
        name: "jobs-profile-work-contexts",
        component: workContexts,
        meta: {
          label: "شرایط کاری",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job/:code/skills",
        name: "jobs-profile-skills",
        component: skills,
        meta: {
          label: "مهارت‌ها",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job/:code/knowledge",
        name: "jobs-profile-knowledge",
        component: knowledge,
        meta: {
          label: "دانش",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job/:code/abilities",
        name: "jobs-profile-abilities",
        component: abilities,
        meta: {
          label: "توانایی‌ها",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job/:code/work-values",
        name: "jobs-profile-work-values",
        component: workValues,
        meta: {
          label: "ارزش‌های کاری",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job/:code/work-styles",
        name: "jobs-profile-work-styles",
        component: workStyles,
        meta: {
          label: "سبک‌های کاری",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job/:code/interests",
        name: "jobs-profile-interests",
        component: interests,
        meta: {
          label: "سبک‌های کاری",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job/:code/educations",
        name: "jobs-profile-educations",
        component: educations,
        meta: {
          label: "تحصیلات",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job/:code/job-zone",
        name: "jobs-profile-job-zone",
        // component: educations,
        meta: {
          label: "منطقه شغلی",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job_matching_person",
        name: "job_matching_person",
        component: jobMatchingPerson,
        meta: {
          label: "بررسی تطابق شغل و شاغل",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "job_matching_person/:code/occupation-data-parvandeh",
        name: "jobs-occupation-data-parvandeh",
        component: occupationDataParvandehList,
        meta: {
          label: "پرونده ها",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
      },
      {
        path: "jobp-references",
        name: "jobp_references",
        redirect: "/jobs-profile/jobp-references/list",
        meta: {
          label: "مدیریت مرجع های شغلی",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "jobp-references-list",
            component: jobpReferencesList,
            meta: {
              label: "مدیریت مرجع های شغلی",
              requiresAuth: true,
              redesigned: true,
              hasBottomNavigation: false,
              hasAudioNotification: false,
            },
          },
        ],
      },
    ],
  },
];
